module.exports = __webpack_public_path__ + "static/media/Sharp-LQ070Y3LG05-Mechanical-Drawing.cd620edd.gif";